
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/rules-of-use",
      function () {
        return require("private-next-pages/rules-of-use.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/rules-of-use"])
      });
    }
  